@if (!isLoading) {
  <div>
    <div id="main-content">
      <div class="top-header">
        @if (toolbarComponent) {
          <ng-container *ngComponentOutlet="toolbarComponent" />
        }
      </div>
      <div class="app-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
